import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import R from 'ramda'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import RatingsActions from '../../Data/Redux/RatingsRedux'
import Tool from '../../Components/ReportsComponents/Tool'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class AvgMonthlyRatings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [{ id: 1, month: 'ENE' }, { id: 2, month: 'FEB' }, { id: 3, month: 'MAR' }, { id: 4, month: 'ABR' },
        { id: 5, month: 'MAY' }, { id: 6, month: 'JUN' }, { id: 7, month: 'JUL' }, { id: 8, month: 'AGO' },
        { id: 9, month: 'SEP' }, { id: 10, month: 'OCT' }, { id: 11, month: 'NOV' }, { id: 12, month: 'DIC' }],
    }
  }

  componentWillMount() {
    if (!this.props.fromCenter) {
      this.props.getRatings()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { ratings, centers, centersInfo } = nextProps
    if (ratings && centers) {
      for (let i = 1; i <= 12; i++) {
        if (ratings[i]) {
          for (let j = 1; j <= centers.length; j++) {
            if (ratings[i][j - 1]) {
              if (centers.length > 0) {
                const selectedCenter = centers.find(center => center.id === ratings[i][j - 1].center_id)
                newState.data[i - 1][selectedCenter.abbreviation] = parseFloat(ratings[i][j - 1].avg_rating)
              }
            } else {
              for (let l = 1; l <= centers.length; l++) {
                if (!newState.data[i - 1][centers[l - 1].abbreviation]) {
                  newState.data[i - 1][centers[l - 1].abbreviation] = null
                }
              }
            }
          }
        } else {
          for (let j = 1; j <= centers.length; j++) {
            newState.data[i - 1][centers[j - 1].abbreviation] = null
          }
        }
        this.setState(newState)
      }
    }
    if (centersInfo && centers) {
      for (let i = 1; i <= 12; i++) {
        if (centersInfo[i]) {
          for (let j = 1; j <= centers.length; j++) {
            if (centersInfo[i][j - 1]) {
              if (centers.length > 0) {
                const selectedCenter = centers.find(center => center.id === centersInfo[i][j - 1].center_id)
                newState.data[i - 1][selectedCenter.abbreviation] = parseFloat(centersInfo[i][j - 1].avg_rating)
              }
            } else {
              for (let l = 1; l <= centers.length; l++) {
                if (!newState.data[i - 1][centers[l - 1].abbreviation]) {
                  newState.data[i - 1][centers[l - 1].abbreviation] = null
                }
              }
            }
          }
        } else {
          for (let j = 1; j <= centers.length; j++) {
            newState.data[i - 1][centers[j - 1].abbreviation] = null
          }
        }
        this.setState(newState)
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getLines = () => {
    const lines = this.props.centers.map((value, index) => {
      return (
        <Line key={index} connectNulls type="monotone" dataKey={value.abbreviation} stroke={this.pickColor(value.abbreviation) ? COLORS[index % COLORS.length] : 'gray'} activeDot={{ r: 8 }} />
      )
    })
    return lines
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  filter = (event) => {
    const newState = { ...this.state }
    const { ratings, centers } = this.props
    for (let i = 1; i <= 12; i++) {
      if (ratings[i]) {
        const selectedCenter = centers.find(center => center.abbreviation === event.currentTarget.id)
        const activeCenterIndex = R.findIndex(R.propEq('center_id', selectedCenter.id))(ratings[i])
        if (newState.data[i - 1][event.currentTarget.id] === '0' || newState.data[i - 1][event.currentTarget.id] === null ) {
          if (ratings[i][activeCenterIndex]) {
            newState.data[i - 1][event.currentTarget.id] = parseFloat(ratings[i][activeCenterIndex].avg_rating)
          }
        } else {
          newState.data[i - 1][event.currentTarget.id] = null
        }
      }
    }
    this.setState(newState)
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] !== '0' && this.state.data[i][name] !== null) {
        count++
      }
    }
    return count > 0
  }


  render() {
    const { centers, fromCenter } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Promedio de ratings: Mensual"
        date={data[0] &&
          { initial: data[0].month, end: data[data.length - 1].month }}
        withOutExcel
        loading={!(centers.length > 0)}
      >
        {centers.length > 0 &&
          <LineChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="month" />
            <YAxis type="number" domain={['0', '5']} />
            <Tooltip content={<Tool withoutTotal withoutCurrency large />} />
            <Legend content={<CustomizedLegend onClick={!fromCenter && this.filter} />} />
            {this.getLines()}
          </LineChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ ratings, centerOptions, centersInfo }) => ({
  ratings: ratings.get.results.avg_monthly_ratings,
  centers: centerOptions.get.results,
  centersInfo: centersInfo.ratings.results.avg_monthly_ratings,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getRatings: () => dispatch(RatingsActions.getRequest({}, true)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AvgMonthlyRatings))



// WEBPACK FOOTER //
// ./src/Containers/Reports/AvgMonthlyRatings.jsx